import type {ReactNode} from 'react';
import React, {useState} from 'react';
import {ConfirmDialog} from 'src/design/molecules/ConfirmDialog';

export interface ConfirmActionButtonProps {
  body: ReactNode;
  onConfirm: () => void | Promise<void>;
  title?: string;
  /** Blocks re-confirming while the confirmed action is in flight. */
  loading?: boolean;
  /** Renders the trigger; `onClick` opens the confirm dialog. */
  renderButton: (onClick: () => void, loading: boolean) => ReactNode;
}

export const ConfirmActionButton: React.FC<ConfirmActionButtonProps> = ({
  body,
  onConfirm,
  title = 'Acknowledgement',
  loading = false,
  renderButton,
}) => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      {renderButton(() => setOpened(true), loading)}
      <ConfirmDialog
        size="md"
        opened={opened}
        title={title}
        body={body}
        buttonTextYes="Yes, I'm sure"
        buttonTextNo="No"
        confirmationButtonDisabled={loading}
        onClose={() => setOpened(false)}
        onConfirm={() => {
          setOpened(false);
          void onConfirm();
        }}
      />
    </>
  );
};
